import { BOAT_RACE_IMAGES, BOAT_RACE_REFERENCE_LINKS_ML } from './boatRacePostUtils';

const GALLERY_IMAGES = {
  heats: BOAT_RACE_IMAGES.heats,
  alleppey: BOAT_RACE_IMAGES.alleppey,
  aranmula: BOAT_RACE_IMAGES.aranmula,
};

/** കേരള വള്ളംകളി & നെഹ്‌റു ട്രോഫി ബോട്ട് റേസ് (NTBR) 2026 — പൂർണ്ണ മലയാളം ഗൈഡ് */
export const KERALA_BOAT_RACE_NTBR_MALAYALAM_POST = {
  id: 'featured-kerala-boat-race-ntbr-2026-malayalam',
  slug: 'kerala-boat-race-nehru-trophy-ntbr-malayalam',
  title: 'കേരള വള്ളംകളി ഗൈഡ്: വള്ളംകളി, 72-ാം NTBR 2026 & നെഹ്‌റു ട്രോഫി ചരിത്രം',
  excerpt:
    'നൂറ്റാണ്ടുകളുടെ ചുണ്ടൻ വള്ളങ്ങൾ കുട്ടനാടിന്റെ കായലുകളിൽ — 2026 ഓഗസ്റ്റ് 22ന് പുന്നമടയിൽ 72-ാം നെഹ്‌റു ട്രോഫി. ചരിത്രം, മത്സര വിവരങ്ങൾ, NTBR എങ്ങനെ കുട്ടനാടിന്റെ ഒളിമ്പിക്സായി മാറി എന്നത്.',
  publishedAt: '2026-08-08T14:00:00.000Z',
  coverImageUrl: BOAT_RACE_IMAGES.hero,
  authorName: 'Daily Sports Life',
  clubName: 'കേരള കായിക വാർത്താ ഡെസ്ക്',
  audience: 'മലയാളി പ്രേക്ഷകർ',
  blogCategory: 'boat-races',
  locale: 'ml',
  boatRaceTopic: 'guide',
  alternateSlug: 'kerala-boat-race-nehru-trophy-ntbr-history',
  featured: true,
  component: 'WellnessGuideBlogArticle',
  theme: 'diet',
  relatedPostsTitle: 'ബന്ധപ്പെട്ട വള്ളംകളി ലേഖനങ്ങൾ',
  relatedPosts: [
    {
      slug: 'kerala-boat-race-live-stream-youtube-malayalam',
      title: 'കേരള വള്ളംകളി ലൈവ്: സൗജന്യ YouTube ചാനലുകൾ',
      blurb: 'DD മലയാളം, Asianet, Manorama — എല്ലാ സൗജന്യ NTBR സ്ട്രീം ലിങ്കുകൾ.',
    },
    {
      slug: 'nehru-trophy-2026-chundan-vallam-malayalam',
      title: '72-ാം നെഹ്‌റു ട്രോഫി 2026: 22 ചുണ്ടൻ വള്ളങ്ങൾ, ക്ലബുകൾ, കാപ്റ്റൻമാർ',
      blurb: '2026 ചുണ്ടൻ പട്ടിക, കാപ്റ്റൻ വിവരങ്ങൾ, ഫോട്ടോകളും വീഡിയോകളും.',
    },
    {
      slug: 'kerala-boat-race-nehru-trophy-ntbr-history',
      title: 'Kerala Boat Race Guide: NTBR 2026 & Nehru Trophy History (English)',
      blurb: 'ഇംഗ്ലീഷ് പതിപ്പ്.',
    },
  ],
  referenceLinks: BOAT_RACE_REFERENCE_LINKS_ML,
  sections: [
    {
      type: 'stats',
      ariaLabel: 'NTBR 2026 സംക്ഷിപ്തം',
      items: [
        { value: '22 ഓഗ 2026', label: '72-ാം നെഹ്‌റു ട്രോഫി' },
        { value: 'പുന്നമട', label: 'ആലപ്പുഴ, കേരളം' },
        { value: '1.4 കി.മീ', label: 'പ്രധാന ട്രാക്ക്' },
        { value: '100–150', label: 'ചുണ്ടനിലെ വരികർ' },
      ],
    },
    {
      type: 'panel',
      title: 'കേരളത്തിന്റെ വള്ളംകളി ഇന്നും എന്തുകൊണ്ട് നിർത്താതെ?',
      paragraphs: [
        'മഴക്കാലം വരുമ്പോൾ കേരളത്തിന്റെ കായലുകൾ വേദിയില്ലാത്ത സ്റ്റേഡിയമായി മാറുന്നു. തീരത്ത് ആളുകൾ നിരന്ന് നിൽക്കുന്നു; **ചുണ്ടൻ വള്ളങ്ങൾ** — പാമ്പിന്റെ തലക്ക്‌രി മുൻഭാഗമുള്ള നീണ്ട വള്ളങ്ങൾ — മുറുക്കൻ താളത്തിൽ മുന്നോട്ട്. ഇതിന് **വള്ളംകളി** എന്ന് പേര്; വെള്ളത്തിലെ കളി, മത്സരവും ഉത്സവവും ഗ്രാമത്തിന്റെ അഭിമാനവും ഒന്നിച്ച്.',
        'ഈ സീസണിലെ ഏറ്റവും വലിയ വേദി **നെഹ്‌റു ട്രോഫി ബോട്ട് റേസ് (NTBR)** — **ആലപ്പുഴയിലെ പുന്നമടക്കായലിൽ**. **കുട്ടനാടിന്റെ** ഗ്രാമങ്ങൾക്ക് ഇവിടെ വിജയം മാസങ്ങളോളം ആഘോഷമാണ്. സന്ദർശകർക്ക് ഇത് ദൈവത്തിന്റെ സ്വന്തം നാടിന്റെ ഏറ്റവും അടിയന്തിര ചിത്രം — ലക്ഷക്കണക്കിന് പ്രേക്ഷകർ തീരത്ത്.',
        'ഈ ഗൈഡിൽ കേരള വള്ളംകളിയുടെ ജീവിത പാരമ്പര്യം, NTBR-ന് പേര് നൽകിയ ചരിത്രം, **2026 ഓഗസ്റ്റ് 22, ശനിയാഴ്ച നടക്കുന്ന 72-ാം പതിപ്പ്** എന്നിവ ഉൾപ്പെടുന്നു.',
      ],
      chips: ['വള്ളംകളി', 'NTBR 2026', 'ചുണ്ടൻ', 'ആലപ്പുഴ', 'ഓണം'],
    },
    {
      type: 'imageGallery',
      title: 'പുന്നമടയുടെ ചിത്രങ്ങൾ',
      intro: 'യഥാർത്ഥ നെഹ്‌റു ട്രോഫി ചിത്രങ്ങൾ (Wikimedia Commons, CC BY-SA).',
      images: [
        {
          url: GALLERY_IMAGES.heats,
          alt: 'നെഹ്‌റു ട്രോഫി 2024 — ചുണ്ടൻ ഹീറ്റ്',
          caption: 'നെഹ്‌റു ട്രോഫി ബോട്ട് റേസ് 2024, പുന്നമട — Varghesepunnamada / Wikimedia.',
        },
        {
          url: GALLERY_IMAGES.alleppey,
          alt: 'നെഹ്‌റു ട്രോഫി, ആലപ്പുഴ',
          caption: 'നെഹ്‌റു ട്രോഫി വള്ളംകളി, ആലപ്പുഴ — Wikimedia Commons.',
        },
        {
          url: GALLERY_IMAGES.aranmula,
          alt: 'കേരള വള്ളംകളി — ചുണ്ടൻ വള്ളങ്ങൾ',
          caption: 'കേരളത്തിലെ ചുണ്ടൻ വള്ളംകളി — Anoopkn / Wikimedia.',
        },
      ],
    },
    {
      type: 'panel',
      title: 'വള്ളംകളി — വെള്ളത്തിലെ ഒളിമ്പിക്സ്',
      paragraphs: [
        '**വള്ളംകളി** ടൂറിസം ആകുന്നതിന് മുൻപ് കേരളത്തിന്റെ ജലമാർഗ്ഗങ്ങളിൽ നിന്നാണ് വളർന്നത്. മധ്യ തിരുവിതാംകൂറിലെ പഴയ കാലത്ത് നീണ്ട പോർവള്ളങ്ങൾ നിർമ്മിച്ചു. കാലക്രമേണ അവ മത്സര വള്ളങ്ങളായി; ഗ്രാമ പോരാട്ടങ്ങൾ യുദ്ധത്തിന് പകരം.',
        '**ഓണം** കാലത്ത് (ജൂലൈ–സെപ്റ്റംബർ) മത്സരങ്ങൾ ഉച്ചസ്ഥായിയിൽ. സീസൺ പലപ്പോഴും **ചമ്പക്കുളം മൂലം വള്ളംകളി**യോടെ തുടങ്ങുന്നു — ഏറ്റവും പഴയ നടക്കുന്ന ഉത്സവങ്ങളിൽ ഒന്ന് — പിന്നീട് നെഹ്‌റു ട്രോഫിയിലേക്കും മറ്റ് മത്സരങ്ങളിലേക്കും.',
        'ഈ കായികത്തിന്റെ പ്രത്യേകത വള്ളം മാത്രമല്ല. മുഴുവൻ ഗ്രാമവും ഒന്നിച്ച് പരിശീലിക്കുന്നു, വരികർക്ക് ഭക്ഷണം, ഗ്രാമ **ചുണ്ടനെ** ദേവത പോലെ കാണുന്നു. ഹിന്ദു, ക്രിസ്ത്യൻ, മുസ്ലിം സമൂഹങ്ങൾ ഒരേ തീരത്ത് ഒരേ അടുക്കള — കേരളത്തിന്റെ സാമൂഹിക ഐക്യത്തിന്റെ ചിത്രം.',
      ],
    },
    {
      type: 'table',
      title: 'മത്സര ദിവസം കാണുന്ന വള്ളങ്ങൾ',
      intro: 'NTBR-യിൽ ഒന്നിലധികം വിഭാഗങ്ങൾ. ചുണ്ടൻ ഫൈനൽ പ്രധാന ആകർഷണം; ചെറിയ വിഭാഗങ്ങളും കായല നിറയ്ക്കും.',
      headers: ['വള്ളം തരം', 'വിവരണം', 'സാധാരണ ക്രൂ', 'ഉത്സവത്തിലെ പങ്ക്'],
      rows: [
        [
          'ചുണ്ടൻ വള്ളം (സ്നേക്ക് ബോട്ട്)',
          '100–138 അടി; പാമ്പിന്റെ തലക്ക്‌രി മുൻഭാഗം; പ്രധാനമായും അഞ്ജിലി മരം',
          '100–150 (വരികർ, അമരക്കാർ, പാട്ടുകാരൻ, താളക്കാർ)',
          'പ്രധാന NTBR ഇവന്റ്; ചാമ്പ്യൻസ് ബോട്ട് ലീഗ് ഉദ്ഘാടനം',
        ],
        ['വെപ്പ് വള്ളം', 'പാരമ്പര്യ പിന്തുണ/പാചക വള്ളം; തനിയെ മത്സരിക്കുന്നു', 'ചുണ്ടനേക്കാൾ ചെറിയ ക്രൂ', 'ആദ്യ ഹീറ്റുകൾ'],
        [
          'ഇരുട്ടുകുത്തി / ഓഡി വള്ളം',
          'വേഗതയേറിയ, ലഘു വള്ളം',
          'ചെറിയ ക്രൂ',
          'പുന്നമട പ്രോഗ്രാമിലെ പ്രത്യേക വിഭാഗങ്ങൾ',
        ],
        ['ചുരുളൻ വള്ളം', 'വക്രമായ ചെറിയ മത്സര വള്ളം', '30–40', 'പ്രാദേശിക മത്സരങ്ങൾ'],
      ],
    },
    {
      type: 'panel',
      title: 'ചുണ്ടൻ വള്ളത്തിനുള്ളിൽ',
      paragraphs: [
        'ചുണ്ടൻ അത്യന്ത ആകൃതി: വളരെ നീളമുള്ള, വളരെ നേർത്ത, തള്ളു വെള്ളത്തിന് അനുയോജ്യം. **മൂത്തശാരി**മാർ പാരമ്പര്യ കൈവേലയിൽ നിർമ്മിക്കുന്നു; തള്ളു ചലിക്കാൻ അനുവദിക്കുന്നു.',
        'മത്സര ദിവസം ക്രൂ ഒരേ ശരീരം പോലെ. അമരക്കാർ നീണ്ട തുനക്കുകളാൽ നിയന്ത്രിക്കുന്നു; പാട്ടുകാരൻ താളം നിശ്ചയിക്കുന്നു; വരികർ മിനിറ്റിൽ 100–120 സ്ട്രോക്ക്. മുൻഭാഗം ഉയർന്നു; പിൻഭാഗം വെള്ളത്തിന് മുകളിൽ. പുന്നമടയിൽ നിരവധി ചുണ്ടനുകൾ വരിയുമ്പോൾ കായല ചരിത്രത്തിന്റെ ജീവചിത്രമായി തോന്നുന്നു.',
      ],
      callout:
        'പ്രധാന വള്ളം ഗ്രാമത്തിന്റേതാണ്. വള്ളത്തിന് സ്പർശിക്കുന്നതും കയറുന്നതും മര്യാദയോടെ — നഗ്നപാദം, തൈലം തേക്കൽ, മാസങ്ങളുടെ പരിശീലനം.',
    },
    {
      type: 'panel',
      title: 'നെഹ്‌റു ട്രോഫി ബോട്ട് റേസിന്റെ ചരിത്രം',
      paragraphs: [
        'NTBR-ന്റെ ആധുനിക പ്രതിഷ്ഠ **1952**-ൽ തുടങ്ങുന്നു. ഇന്ത്യയുടെ ആദ്യ പ്രധാനമന്ത്രി **ജവഹർലാൽ നെഹ്‌റു** ആലപ്പുഴ സന്ദർശിച്ചു. **കുട്ടനാട്** വെള്ളത്തിൽ അദ്ദേഹത്തെ ചുണ്ടൻ വള്ളങ്ങളുടെ ഘോഷയാത്രയോടെ സ്വാഗതം ചെയ്തു.',
        'യാദൃശ്ചിക മത്സരം നടന്നു. **നടുഭാഗം ചുണ്ടൻ** വിജയിച്ചു. നെഹ്‌റു കാഴ്ചയിൽ മയങ്ങി വിജയി വള്ളത്തിൽ കയറി — സുരക്ഷാ നിയമങ്ങൾ മറികടന്ന് — ജെറ്റിയിലേക്ക് യാത്ര.',
        'ഡിസംബർ 1952-ൽ നെഹ്‌റു **വെള്ളി ട്രോഫി** അനുദാനം ചെയ്തു — ചുണ്ടൻ ആകൃതിയിൽ. «ട്രാവൻകൂർ കൊച്ചിൻ സമൂഹജീവിതത്തിന്റെ അനന്യമായ ഭാഗമാണ് വള്ളംകളി» എന്ന വാക്കുകൾ ഇന്നും ഇവന്റ് നിർവചിക്കുന്നു. **പ്രധാനമന്ത്രിയുടെ ട്രോഫി** പിന്നീട് **നെഹ്‌റു ട്രോഫി ബോട്ട് റേസ്** ആയി.',
        'ആ ട്രോഫിയിൽ നിന്ന് കുട്ടനാടിന്റെ ദേശീയ ജലോത്സവം. ഓഗസ്റ്റ് രണ്ടാം ശനിയാഴ്ച (2026-ൽ **22 ഓഗസ്റ്റ്**) നടക്കുന്ന NTBR ഓരോ ബോട്ട് ക്ലബ്ബിന്റെയും സ്വപ്നം. **2020, 2021**-ൽ കോവിഡ് കാരണം റദ്ദാക്കി; തിരിച്ചുവന്നപ്പോൾ സാംസ്കാരിക കാർണിവലും പ്രൊഫഷണൽ കാലണ്ടറിന്റെ തുടക്കവും.',
      ],
      chips: ['1952', 'നടുഭാഗം ചുണ്ടൻ', 'വെള്ളി ട്രോഫി', 'കുട്ടനാട്', 'പുന്നമട'],
    },
    {
      type: 'table',
      title: 'NTBR — പ്രധാന നാഴികക്കല്ലുകൾ',
      headers: ['കാലം', 'സംഭവം'],
      rows: [
        ['13–14ാം നൂറ്റാണ്ട് (പുരാവൃത്തം)', 'പോർവള്ളങ്ങൾ — ഇന്നത്തെ ചുണ്ടൻ'],
        ['~400 വർഷം ചമ്പക്കുളം', 'ക്ഷേത്ര ബന്ധിത വള്ളംകളി'],
        ['1952', 'നെഹ്‌റു സന്ദർശനം; നടുഭാഗം വിജയം; നെഹ്‌റു വള്ളത്തിൽ'],
        ['ഡിസം 1952', 'വെള്ളി ട്രോഫി; വാർഷിക മത്സരം'],
        ['20–21ാം നൂറ്റാണ്ട്', 'ലക്ഷക്കണക്കിന് പ്രേക്ഷകർ; ടിവി; അന്തർദേശീയ സന്ദർശകർ'],
        ['2020–2021', 'കോവിഡ് റദ്ദാക്കൽ'],
        ['2019 മുതൽ', 'ചാമ്പ്യൻസ് ബോട്ട് ലീഗ്; NTBR ഉദ്ഘാടനം'],
        ['22 ഓഗ 2026', '72-ാം നെഹ്‌റു ട്രോഫി, പുന്നമട'],
      ],
    },
    {
      type: 'panel',
      title: 'വരാനിരിക്കുന്നത്: 72-ാം നെഹ്‌റു ട്രോഫി (2026)',
      paragraphs: [
        'കലണ്ടറിൽ അടയാളം: **72-ാം നെഹ്‌റു ട്രോഫി ബോട്ട് റേസ്** — **2026 ഓഗസ്റ്റ് 22, ശനിയാഴ്ച**, **ആലപ്പുഴ, പുന്നമട**. **നെഹ്‌റു ട്രോഫി ബോട്ട് റേസ് സൊസൈറ്റി**യും **ആലപ്പുഴ ജില്ലാ ഭരണവും** സംഘടിപ്പിക്കുന്നു. ഔദ്യോഗിക സൈറ്റിൽ ഓൺലൈൻ ടിക്കറ്റ്.',
        'പ്രധാന ട്രാക്ക് **1.4 കി.മീ**. **20-ലധികം ചുണ്ടൻ** വള്ളങ്ങളും ചെറിയ വിഭാഗങ്ങളും. പ്രദർശനങ്ങൾ, തുലാസരങ്ങൾ, ഹീറ്റുകൾ — ചുണ്ടൻ ഫൈനലിലേക്ക്.',
        '2026-ൽ **ചാമ്പ്യൻസ് ബോട്ട് ലീഗ് (CBL)** തുടങ്ങുന്നു; NTBR ആദ്യ വേദി. ക്ലബുകൾ റസിഡൻഷ്യൽ ക്യാമ്പുകൾ — രാവിലെ/വൈകുന്നേരം പരിശീലനം.',
        'വിജയി ടീമിന് സമ്മാനം **₹25 ലക്ഷം** വരെ — പോരാട്ടം കടുത്തതാണ്.',
      ],
      orderedList: [
        '**തീയതി:** 2026 ഓഗസ്റ്റ് 22 (ശനിയാഴ്ച)',
        '**പതിപ്പ്:** 72-ാം നെഹ്‌റു ട്രോഫി',
        '**സ്ഥലം:** പുന്നമടക്കായല്‍, ആലപ്പുഴ',
        '**ദൂരം:** ~1.4 കി.മീ ചുണ്ടൻ ട്രാക്ക്',
        '**റെയിൽവേ:** ആലപ്പുഴ (~5 കി.മീ)',
        '**വിമാനത്താവളം:** കൊച്ചി (COK), ~85 കി.മീ',
        '**ടിക്കറ്റ്:** nehrutrophy.nic.in',
      ],
      callout:
        'രണ്ട് ലക്ഷത്തിലധികം പ്രേക്ഷകർ. നേരത്തേ എത്തുക; വെള്ളം, സൺസ്ക്രീൻ കൊണ്ടുപോകുക. ഔദ്യോഗിക സൈറ്റിൽ ഷെഡ്യൂൾ സ്ഥിരീകരിക്കുക.',
    },
    {
      type: 'panel',
      title: 'മത്സര ദിവസത്തിന്റെ അനുഭവം',
      paragraphs: [
        'പ്രഭാതം ജലോത്സവം: അലങ്കരിച്ച വള്ളങ്ങൾ, **ചെണ്ട** താളം. ഉച്ചയ്ക്ക് ശേഷം കായല നിറയുന്നു — ക്ലബ് നിറങ്ങൾ, തൂണുകൾ, ക്യാമറകൾ.',
        'ഫൈനലിസ്റ്റുകൾ സ്റ്റാർട്ട് ലൈനിൽ എത്തുമ്പോൾ ശബ്ദം മാറുന്നു. **വഞ്ചിപ്പാട്ട്** മത്സര താളത്തിലേക്ക്. വരികൾ ഒരുമിച്ച്. മഴക്കാല വെളിച്ചത്തിൽ തുള്ളി വെള്ളം — നെഹ്‌റു എഴുപത്തിനാല് വർഷം മുമ്പ് വള്ളത്തിൽ കയറിയ കാരണവും, കുടുംബങ്ങൾ ഇന്നും ഓഗസ്റ്റിലെ ഒരു ശനിയാഴ്ചയ്ക്കായി കാത്തിരിക്കുന്നതും.',
      ],
      list: [
        '**വഞ്ചിപ്പാട്ട്** — നൂറ് വരികളുടെ താളം.',
        '**അമരക്കാർ** — ചെറിയ തിരുത്തലുകൾ വിജയം നിശ്ചയിക്കുന്നു.',
        'വിജയത്തിന് ശേഷം ഗ്രാമ ആഘോഷം — ഭക്ഷണം, വെടിക്കെട്ട്, ഘോഷയാത്ര.',
        'ടിവി/സ്ട്രീമിംഗ് — ലോകമെമ്പാടുമുള്ള മലയാളികൾ.',
      ],
    },
    {
      type: 'panel',
      title: 'കേരള കലണ്ടറിലെ മറ്റ് വള്ളംകളികൾ',
      paragraphs: ['NTBR ശീർഷകമാണ്; സീസൺ ഒരു സർക്യൂട്ട്.'],
      list: [
        '**ചമ്പക്കുളം മൂലം** — പമ്പാ; പഴയ പാരമ്പര്യം.',
        '**ആറന്മുള ഉത്രട്ടാഥി** — പവിത്രമായ പേജന്റ്; പാർത്ഥസാരഥി ക്ഷേത്രം.',
        '**പായിപ്പാട്, തഴത്തങ്ങാടി, കുമരകം** — പ്രാദേശിക മത്സരങ്ങൾ.',
        '**പ്രസിഡന്റ്സ് ട്രോഫി** — തീരത്തെക്കാൾ വിശാലമായ ഭൂപടം.',
      ],
    },
    {
      type: 'panel',
      title: 'NTBR 2026 സന്ദർശകർക്ക്',
      orderedList: [
        'ആലപ്പുഴ താമസം മുൻകൂട്ടി ബുക്ക് — ഹോട്ടൽ, ഹൗസ്ബോട്ട്.',
        '**ഔദ്യോഗിക NTBR പോർട്ടൽ** വഴി ടിക്കറ്റ്.',
        'മത്സരത്തിന് മുൻപ്/ശേഷം ശാന്തമായ കായൽ യാത്ര.',
        'വിദേശത്ത് നിന്നുള്ള മലയാളികൾക്ക് — NAMSL സോക്കർ പോലെ ഗ്രാമ അഭിമാനം, വെള്ളത്തിലെ പതിപ്പ്.',
        'വള്ളത്തിനും തീരത്തിനും മര്യാദ.',
      ],
      callout: {
        text: 'ഔദ്യോഗിക വെബ്സൈറ്റിൽ ഷെഡ്യൂൾ പരിശോധിക്കുക →',
        url: 'https://nehrutrophy.nic.in/',
      },
    },
  ],
};
